module.exports = __webpack_public_path__ + "static/media/presentation.019981e1.pptx";